import { useState } from "react";
import { Button, Switch, TextField } from "@mui/material";
import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  editPatientButton,
  DeletePatientButton,
  registerPatientButtonStyles,
  addButtonPadding,
} from "../../common/commonStyles";
import Grid from "@mui/material/Grid";
import "../../common/Common.css";
import { DataGrid } from "@mui/x-data-grid";
import { checkFormValidation } from "../../shared/helper";
import UserCreationForm from "./UserCreationForm";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import api from "../../services/api";

export default function UserTable(props) {
  const { branchId, userDetails, getUsersDetail, roles } = props;
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    address: "",
    email: "",
    name: "",
    phone_number: "",
    role: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [userID, setUserID] = useState();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const handleOpen = () => setOpen(true);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (reason === "escapeKeyDown") {
      return;
    }
    setFormData({
      address: "",
      email: "",
      name: "",
      phone_number: "",
      role: "",
    });
    setOpen(false);
  };

  const handleSnackClose = () => setSnackbarOpen(false);

  const requiredFields = ["address", "email", "name", "phone_number", "role"];
  const isFormValid = checkFormValidation(formData, requiredFields);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const filteredRows = userDetails.filter((row) =>
    Object.values(row).some(
      (val) =>
        val && val.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );
  const columns = [
    { field: "name", headerName: "Name", flex: 1, minWidth: 150 },
    { field: "email", headerName: "Email", flex: 1.5, minWidth: 200 },
    { field: "phone_number", headerName: "Mobile", width: 140 },
    { field: "address", headerName: "Address", flex: 2, minWidth: 220 },
    { field: "role", headerName: "Role", width: 120 },
    {
      field: "is_active",
      headerName: " Is Active",
      width: 110,
      editable: false,
      sortable: false,
      renderCell: (param) => (
        <Switch
          defaultChecked={param.row.is_active}
          onChange={(event) => handleToggleIsActive(event, param.row)}
        />
      ),
    },
    {
      field: "",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const isActive = params.row.is_active;

        return (
          <Box className="center-align">
            <BorderColorIcon
              sx={{
                ...editPatientButton,
                color: isActive ? undefined : "#ccc",
                pointerEvents: isActive ? "auto" : "none",
              }}
              onClick={() => {
                handleUserEdit(params.row.id);
              }}
            />
            <DeleteIcon
              sx={DeletePatientButton}
              onClick={() => {
                // handleServiceDelete(params.row.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleToggleIsActive = async (event, row) => {
    const newValue = event.target.checked;
    try {
      await api.patch(`app/management/users/${row.id}`, {
        is_active: newValue,
      });
      if (typeof getUsersDetail === "function") {
        getUsersDetail(); // parent should refetch and pass updated `rows` again
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleCreateUser = async () => {
    if (!isFormValid) {
      setSnackbarOpen({
        status: true,
        message: "Please fill all required fields correctly.",
        severity: "error",
      });
      return;
    }
    if (isEditClicked) {
      sendUserEdit();
    } else {
      try {
        const response = await api.post(
          `app/management/users/${branchId}`,
          formData
        );

        if (response.status === 200) {
          setFormData({
            address: "",
            email: "",
            name: "",
            phone_number: "",
            role: "",
          });
          setSnackbarOpen({
            status: true,
            message: "User created successfully with default password!",
          });
          handleClose();
          getUsersDetail();
        }
      } catch (error) {
        setSnackbarOpen({
          status: true,
          message:
            error?.response?.data?.detail[0].msg ||
            "Something went wrong ! Please try again",
          severity: "error",
        });
      }
    }
  };
  const handleUserEdit = async (id) => {
    setUserID(id);
    setIsEditClicked(true);
    await getDetailsUserWise(id);
    handleOpen();
  };
  const getDetailsUserWise = async (id) => {
    try {
      let userData = await api.get(`app/management/users/?user_id=${id}`);
      if (userData?.status === 200) {
        setFormData({
          address: userData?.data[0]?.address,
          email: userData?.data[0]?.email,
          name: userData?.data[0]?.name,
          phone_number: userData?.data[0]?.phone_number,
          role: userData?.data[0]?.role,
        });
      } else {
        setSnackbarOpen({
          status: true,
          message: "Something went wrong. Please try again later.",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbarOpen({
        status: true,
        message: "Something went wrong. Please try again later.",
        severity: "error",
      });
    }
  };
  const sendUserEdit = async () => {
    setIsEditClicked(true);
    try {
      let updatedUserData = await api.patch(
        `app/management/users/${userID}`,
        formData
      );
      if (updatedUserData?.status === 200) {
        setFormData({
          address: "",
          email: "",
          name: "",
          phone_number: "",
          role: "",
        });
        setSnackbarOpen({
          status: true,
          message: "User updated successfully!",
        });
        handleClose();
        getUsersDetail();
      }
    } catch (error) {
      setSnackbarOpen({
        status: true,
        message: "Something went wrong. Please try again later.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Box className="tabcontent_box">
        <Grid
          container
          spacing={2}
          className="patientTable-btnstack"
          display="flex"
          alignItems="center"
        >
          <Grid size={8}>
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, addButtonPadding]}
              size="small"
              onClick={handleOpen}
            >
              Add New User
            </Button>
          </Grid>
          <Grid size={4} sx={{ textAlign: "right" }}>
            <TextField
              size="small"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Grid>
        </Grid>

        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            sx={{
              fontFamily: "Nunito, sans-serif",
              // Cell (row content) font size
              "& .MuiDataGrid-cell": {
                fontSize: "12px",
              },

              // Header font size
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "13px",
                fontWeight: "bold",
              },
            }}
            rows={filteredRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            // checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </Box>
      <UserCreationForm
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        formData={formData}
        setFormData={setFormData}
        handleInputChange={handleInputChange}
        handleCreateUser={handleCreateUser}
        isFormValid={isFormValid}
        isEditClicked={isEditClicked}
        roles={roles}
      />
      <ReusableSnackbar
        open={snackbarOpen.status}
        message={snackbarOpen.message}
        onClose={handleSnackClose}
        severity={snackbarOpen.severity}
      />
    </>
  );
}
